import React, { useEffect, useState } from 'react';
import { Button, Collapse, Icon, Checkbox, InputNumber, Table, Tag } from 'antd';
import { Widget } from '@digital/ui';
import {
  getAtivacaoContratoAdministradores,
  updateAtivacaoContratoAdministradores,
  AtivacaoContratoAdministrador,
} from '@app/api/ativacaoContratoAdministradores';

const { Panel } = Collapse;

const ConfiguracaoAdministradoresContrato = () => {
  const [itens, setItens] = useState<AtivacaoContratoAdministrador[]>([]);
  const [carregando, setCarregando] = useState(false);

  const carregar = () => {
    setCarregando(true);
    getAtivacaoContratoAdministradores()
      .then(resultado => setItens(resultado || []))
      .finally(() => setCarregando(false));
  };

  useEffect(() => {
    carregar();
  }, []);

  const atualizarItem = (usuarioId: string, alteracoes: Partial<AtivacaoContratoAdministrador>) => {
    setItens(lista => lista.map(item => (item.usuarioId === usuarioId ? { ...item, ...alteracoes } : item)));
  };

  const alternar = (item: AtivacaoContratoAdministrador, selecionado: boolean) => {
    if (selecionado) {
      const maiorOrdem = Math.max(0, ...itens.filter(x => x.selecionado).map(x => x.ordem || 0));
      atualizarItem(item.usuarioId, { selecionado: true, ordem: item.ordem || maiorOrdem + 1 });
      return;
    }

    atualizarItem(item.usuarioId, { selecionado: false, ordem: undefined });
  };

  const salvar = () => {
    updateAtivacaoContratoAdministradores({
      administradores: itens.map(item => ({
        usuarioId: item.usuarioId,
        ordem: item.ordem || 0,
        selecionado: item.selecionado,
      })),
    }).then(resultado => {
      if (!resultado || resultado.valid !== false) carregar();
    });
  };

  return (
    <Collapse bordered={false} expandIcon={() => <Icon type="arrows-right_4" />}>
      <Panel key="configuracoesAdministradoresContrato" header="Administradores da ativação de contratos">
        <Widget
          actions={[
            <Button type="primary" onClick={salvar}>
              Salvar
            </Button>,
          ]}>
          <p>
            Selecione os administradores elegíveis e informe a ordem da distribuição global. Cada novo handover
            reserva o próximo administrador da sequência.
          </p>
          <Table
            rowKey="usuarioId"
            loading={carregando}
            dataSource={itens}
            pagination={false}
            columns={[
              {
                title: 'Selecionado',
                key: 'selecionado',
                width: 110,
                render: (_: any, item: AtivacaoContratoAdministrador) => (
                  <Checkbox
                    checked={item.selecionado}
                    onChange={evento => alternar(item, evento.target.checked)}
                  />
                ),
              },
              { title: 'Administrador', dataIndex: 'nome', key: 'nome' },
              { title: 'E-mail', dataIndex: 'email', key: 'email' },
              {
                title: 'Status',
                key: 'ativo',
                width: 110,
                render: (_: any, item: AtivacaoContratoAdministrador) =>
                  item.ativo ? <span>Ativo</span> : <Tag color="orange">Inativo</Tag>,
              },
              {
                title: 'Ordem',
                key: 'ordem',
                width: 120,
                render: (_: any, item: AtivacaoContratoAdministrador) => (
                  <InputNumber
                    min={1}
                    value={item.ordem}
                    disabled={!item.selecionado}
                    onChange={ordem => atualizarItem(item.usuarioId, { ordem: ordem || undefined })}
                  />
                ),
              },
            ]}
          />
        </Widget>
      </Panel>
    </Collapse>
  );
};

export default ConfiguracaoAdministradoresContrato;
